<template>
  <div id="app">
    <GlobalError :message="appState.errorMessage" />
    <div class="loader" v-if="!appState.isInitialized">
      <VFullScreenLoader />
    </div>
    <div v-else>
      <Login v-if="!userState.isLoggedIn" />
      <div class="structure" v-else>
        <div class="sidebar">
          <Sidebar />
        </div>
        <div class="content">
          <Topbar />
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";
import store from "@/store";
import GlobalError from "@/components/errors/GlobalError";
import Login from "@/components/Login";
import VFullScreenLoader from "@/components/loading/VFullScreenLoader";

import Sidebar from "@/components/Sidebar";
import Topbar from "@/components/Topbar";

export default {
  components: { GlobalError, Login, Sidebar, Topbar, VFullScreenLoader },
  setup() {
    store.dispatch("app/initialize");

    const appState = reactive(store.state.app);
    const userState = reactive(store.state.user);

    return {
      appState,
      userState
    };
  }
};
</script>

<style lang="scss">
body,
input,
button {
  font-family: "Noto Sans", sans-serif;
}

body {
  background-color: #fff;
}

.structure {
  & > .sidebar {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    width: 280px;
    box-sizing: border-box;
    border: 1px solid rgba(0, 0, 0, 0.05);
    background-color: #000;
  }
  & > .content {
    left: 280px;
    position: fixed;
    top: 66px;
    right: 0px;
    bottom: 0px;
    overflow: auto;
    background-color: #fafafa;
  }
}

.vm--overlay {
  background: rgba(30, 30, 30, 0.7);
}

.modal {
  border-radius: 12px;
  box-shadow: 0 9px 3px -4px rgba(0, 0, 0, 0.05);
  background-color: #fff;
  background: linear-gradient(180deg, #fff 90%, #ececec 100%);
  z-index: 1000;
}

.u-vam {
  vertical-align: middle;
}

.u-click {
  &:active:not(.is-disabled) {
    transform: translateY(1px);
  }
}
</style>
